import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { switchMap  } from 'rxjs/operators';
@Component({
  selector: 'kett-refund-cod-preview',
  templateUrl: 'tracking-item-refund-cod-preview.html',
  styleUrls: ['tracking-item-refund-cod-preview.css']
})

export class TrackingItemRefundCodPdfPreview implements OnInit {
  pdfUrl: SafeResourceUrl | null = null;
  pdfBase64: string;
  pdfSrc: SafeResourceUrl;
  url: string
  con: string
  base64Pdf: string
  isPdfNull: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<TrackingItemRefundCodPdfPreview>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _HttpClient: HttpClient,
    private sanitizer: DomSanitizer,
    @Inject(PLATFORM_ID) private platformId: any
  ) { this.con = data.con;}

 async getPdfFromApi() {
     let apiUrl = ['th.kex-express.com','th.kerryexpress.com'].includes(window.location.hostname) ?  `https://${window.location.hostname}/track/api/Shipment/GetCodPaymentVoucher/`  : 'http://10.112.85.112:9001/track/api/Shipment/GetCodPaymentVoucher/';
     apiUrl +=  this.con;
    // API call to get the base64 PDF data
    this._HttpClient.get(apiUrl, { responseType: 'text' }).subscribe(
      (base64Data: string | null) => {
        if (base64Data != null && base64Data != '') {
 
          const unsafeUrl = 'data:application/pdf;base64,' + base64Data;
          // Sanitize the URL to make it safe for use in the template
          this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl); 
          this.isPdfNull = false;
        } else {
          this.pdfSrc = this.sanitizer.bypassSecurityTrustResourceUrl(null);
          this.isPdfNull = true;
        }
      },
      (error) => {
        console.error('API call failed', error);
        this.isPdfNull = true;
      }
    );

  }

  ngOnInit() {
    this.getPdfFromApi();
    console.log('this.isPdfNull => ' + this.isPdfNull);
  }

 isStringValid(input: string | null | undefined): boolean {
    return input !== null && input !== undefined && input.trim() !== '' && input != 'null' ;
}

}
